(function (global) {
  (function (n) {
    'use strict';
  })(global);

  /**
   * Thực hiện render file js theo môi trường
   */
  (() => {
    'use strict';

    function renderScr(src, callback) {
      let js = document.createElement('script');
      js.src = src;

      // Thêm sự kiện sau khi load thành công
      if (callback && typeof callback == 'function') {
        if (js.readyState) {
          // only required for IE <9
          js.onreadystatechange = function () {
            if (js.readyState === 'loaded' || js.readyState === 'complete') {
              js.onreadystatechange = null;
              callback();
            }
          };
        } else {
          //Others
          js.onload = function () {
            callback();
          };
        }
      }

      document.head.append(js);
    }

    // Misa Notify
    renderScr(`${window._misaNotify.CdnBaseUrl}${window._misaNotify.CdnLibUrl}`, () => {
      if (window.MISANotifyHelper) {
        window.MISANotifyHelper.init({
          // selector của element để render header thông báo vào. Mặc định là "body"
          headerContainer: 'body',
          // đường dẫn Backend của ứng dụng thông báo
          integrationURL: window._misaNotify.IntegrationUrl,
          // id người dùng
          userId: null,
          // email người dùng
          email: null,
          // tên người dùng
          fullName: null,
          // Mã ứng dụng bên hệ thống thông báo
          appCode: window._misaNotify.AppCode,
          // Gọi khi người dùng nhấn đóng, ẩn thông báo dạng header
          afterHideHeader: function () {
            //refresh layout here
            document.body.classList.remove('has-notify-on-head');
          },
          // Gọi khi thông báo dạng header hiện ra trên phần mềm
          afterShowHeader: function () {
            //refresh layout here
            document.body.classList.add('has-notify-on-head');

            // bên misa notify kiến nghị Khi hiển thị notify trên cùng thì không hiển thị thông báo hết hạn tài nguyên nữa
            if (document.body.classList.contains('has-expired-notify') && window._mainLayout?.wetInfo?.Top) {
              document.body.classList.remove('has-expired-notify');
              delete window._mainLayout.wetInfo.Top;
            }
          },
        });
      }
    });

    // Misa New feature
    renderScr(`${window._misaNewFeature.CdnBaseUrl}${window._misaNewFeature.CdnLibUrl}`, () => {
      if (window.MISANewFeature) {
        MISANewFeature.init({
          apiUrl: window._misaNewFeature.ApiUrl,
          appCode: window._misaNotify.AppCode,
          language: 'vi',
          version: window._misaNewFeature.Version,
          historyLink: window._misaNewFeature.HistoryUrl,
          autoShowNew: false,
          isNewFeature: data => {
            return true;
          },
        });
      }
    });

    // MisaID Profile
    window._misaIdProfileReady = new Promise((resolve) => {
      renderScr(`${window._misaId.cdnUrl}${window._misaId.profile}`, resolve);
    });
  })();
})();
